/**
 * The night sky behind the app chrome: a deep navy rather than black, so it reads as space in
 * light mode and still stands apart from dark mode's near-black cards.
 */
export const SPACE_CHROME_COLOR = "#0e1631";

/**
 * A `--color-*` variable holding `SPACE_CHROME_COLOR` beneath `SpaceThemeScope` while the space
 * background is on, for colour props that take a token name (e.g. `ScrollEdgeFade`).
 */
export const SPACE_CHROME_COLOR_VARIABLE = "--color-space-chrome";

/** Colours drawn over `SPACE_CHROME_COLOR`. Mostly blue, as deep-field photographs are. */
export const SPACE_BACKDROP_COLORS = {
  band: "rgb(190, 205, 255)",
  bandOpacity: 0.13,
  constellation: "rgb(210, 220, 255)",
  constellationOpacity: 0.3,
  glint: "rgb(255, 255, 255)",
  glintHalo: "rgb(150, 180, 255)",
  glintHaloOpacity: 0.55,
  nebulae: [
    { color: "rgb(45, 90, 200)", opacity: 0.42 },
    { color: "rgb(30, 125, 170)", opacity: 0.26 },
    { color: "rgb(150, 70, 170)", opacity: 0.2 },
  ],
  star: "rgb(255, 255, 255)",
} as const;

/**
 * Theme tokens (HSL channels, as in `global.css`) for content drawn straight onto the sky, such
 * as the tab bar's icons: light ink instead of the theme's dark ink.
 */
export const SPACE_SKY_FOREGROUND_CHANNELS = {
  foreground: "0 0% 100%",
  "muted-foreground": "226 32% 74%",
  primary: "0 0% 100%",
} as const;
